import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Grid,
  IconButton,
  Typography,
  Hidden,
} from '@material-ui/core';

import {
  TimelineOutlined,
  CardMembershipOutlined,
  HomeOutlined,
  BarChartOutlined,
  AssignmentTurnedInOutlined,
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    backgroundColor: 'transparent',
    position: 'fixed',
    zIndex: 10,
    color: 'white',
    width: '90vw',
    left: '50%',
    transform: 'translateX(-50%)',

    '@media (max-width: 600px)': {
      width: '100vw',
      padding: '0 10px',
    },
  },
  container: {
    padding: 0,
    height: '90px',
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',

    '@media (max-width: 600px)': {
      gap: theme.spacing(1),
    },
  },
  titleGrid: {
    overflowY: 'hidden',
    cursor: 'pointer',
    width: 165,
  },
  title: {
    cursor: 'pointer',
    color: 'white',
  },
  menuGrid: {
    flex: 0.5,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  iconButton: {
    color: 'white',
  },
  profileOutlined: {
    border: '1px solid rgba(255, 255, 255, 0.4)',
    borderRadius: 5,
    padding: 10,
  },
}));

const GenAIHeader = ({
  title,
  hideNav,
  children,
  goToLink,
}) => {
  const classes = useStyles();

  const iconButtons = [
    { path: '/', icon: <HomeOutlined /> },
    { path: '/certify', icon: <CardMembershipOutlined /> },
    { path: '/path', icon: <TimelineOutlined /> },
    { path: '/coach', icon: <AssignmentTurnedInOutlined /> },
    { path: '/reports', icon: <BarChartOutlined /> },
  ];

  return (
    <Box className={classes.headerContainer}>
      <Grid
        container
        alignItems="center"
        justify="space-between"
        className={classes.container}
      >
        <Hidden smDown>
          <Grid
            item
            onClick={() => goToLink('/')}
            className={classes.titleGrid}
          >
            <Typography>{title}</Typography>
          </Grid>
        </Hidden>
        {!hideNav && (
          <Grid item className={classes.menuGrid}>
            {iconButtons.map(({ path, icon }, index) => (
              <IconButton
                key={index}
                className={classes.iconButton}
                onClick={() => goToLink(path)}
              >
                {icon}
              </IconButton>
            ))}
          </Grid>
        )}
        {children}
      </Grid>
    </Box>
  );
};

GenAIHeader.propTypes = {
  title: PropTypes.string.isRequired,
  hideNav: PropTypes.bool.isRequired,
  children: PropTypes.node,
  goToLink: PropTypes.func.isRequired,
};

export default GenAIHeader;
